import React from "react";
import SwIcon from "./icons/domino/sw_icon";

const Sw = ({item, bidib}) => {
    return (
        <SwIcon item={item} bidib={bidib}/>
    )
}

export default Sw
